import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { WEBAPIMETHOD } from '@/utils/webApis'
import { Validations } from '@/utils/validations'
import { IsEqual } from '@/utils/varsManipulations'
import { DomainContext } from '@/context/DomainContext'

export const LoadListDefault = {
  endPoint: () => Promise.resolve({ data: {}, totalCount: 0 }),
  params: [],
  depArr: [],
  defaultValue: {},
  allowFetch: true,
  shortPullTime: 0,
  subLogic: (data) => { }
}

export const useGet = (callObject = LoadListDefault) => {

  const { setLoading } = useContext(DomainContext)

  const [isPending, toggleIsPending] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const [result, setResult] = useState(callObject?.defaultValue || {})

  const { i18n } = useTranslation()

  const fetchData = (needLoading = true) => {

    if (!callObject?.allowFetch) {
      callObject?.subLogic?.(callObject?.defaultValue)
      setResult?.(callObject?.defaultValue)
      return
    }
    if (needLoading) {
      setLoading?.(l => l + 1)
      toggleIsPending(true)
    }

    callObject?.endPoint?.(...callObject?.params)?.then((res) => {
      if (!IsEqual(res.data, result)) {
        setTotalCount(res?.totalCount || 0)
        setResult(res?.data || callObject?.defaultValue || {})
        callObject?.subLogic?.(res?.data || callObject?.defaultValue || {})
      }
    })?.catch((err) => { })?.finally(() => {
      if (needLoading) {
        setLoading?.(l => l - 1)
        toggleIsPending(false)
      }
    })
  }

  useEffect(() => {
    const timeOutFetch = WEBAPIMETHOD.TimeOut(() => fetchData(), 100)
    timeOutFetch.Perform()
    return () => timeOutFetch.Clear()
  }, [callObject?.allowFetch, ...callObject?.depArr?.toString(), ...callObject?.params?.toString(), i18n?.language])


  useEffect(() => {

    if (!callObject?.shortPullTime) return

    const interval = WEBAPIMETHOD.Interval(() => fetchData(false), callObject?.shortPullTime)

    if (Validations.isHaveValue(result) && !isPending) interval.Perform()

    return () => interval.Clear()
  }, [])

  return { totalCount, result, isPending, fetchData }
}

